var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoOnlyAnimated = function SvgLogoOnlyAnimated(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.312 188.833C133.116 194.708 119.443 198 105 198C56.0149 198 15.8754 160.128 12.2645 112.067L145.312 188.833ZM157.499 181.776C181.955 165.02 198 136.884 198 105C198 73.1119 181.951 44.9723 157.49 28.2178L157.499 181.776ZM145.305 21.1637L12.2659 97.914C15.8862 49.862 56.0215 12 105 12C119.44 12 133.111 15.2909 145.305 21.1637ZM1.32709e-07 104.99C-1.65886e-07 104.993 1.32709e-07 104.997 1.32709e-07 105C1.32709e-07 162.99 47.0101 210 105 210C162.99 210 210 162.99 210 105C210 47.0101 162.99 0 105 0C47.0134 0 0.00529827 47.0048 1.32709e-07 104.99ZM24.0127 104.991L145.49 34.9104L145.499 175.087L24.0127 104.991Z",
    fill: "#DEAF38"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    attributeType: "xml",
    from: "0 105 105",
    to: "360 105 105",
    dur: "3s",
    repeatCount: "indefinite"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoOnlyAnimated, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-only-animated.2d395e95.svg";
export { ForwardRef as ReactComponent };